import PiwikReactRouter from 'piwik-react-router';
import { envs } from '../../envs';
import { capitalizeFirstLetter } from 'components/pages/products/ProductTable/columns/helper';

type PiwikWrapper = {
  push: (args: string[]) => void;
};

const createPiwik = (): PiwikWrapper => ({
  push:
    envs.REACT_APP_MATOMO_URL && envs.REACT_APP_MATOMO_SITE_ID
      ? PiwikReactRouter({
          url: envs.REACT_APP_MATOMO_URL,
          siteId: envs.REACT_APP_MATOMO_SITE_ID,
          trackErrors: true,
          // Link tracking is nice to get the pages
          //  the user clicks saved but we still need
          //  to track which pages are open therefore
          // we have a new function to help us achieve
          //  that trackMatomoPage
          enableLinkTracking: true
        }).push
      : (args: string[]) => {
          // eslint-disable-next-line no-console
          console.warn(
            'Matomo is not enabled on this environment, dropping the event...',
            args
          );
        }
});

const piwik = createPiwik();

export default piwik;

// helper function
export const trackSearchEvent = (
  action: string | undefined,
  message: string
) => {
  if (!action) {
    return;
  }
  piwik.push(['trackEvent', 'Search', action, message]);
  piwik.push(['trackGoal', '1']);
};

// trackTreeEvent is to be used when we have more than 2 elements to save, this way its easier to analyze in matomo in a tree like structure

// 1 - Where are we? Covalo, PUIG, etc...
// 2 - Type of user: user authenticated or user not authenticated
// 3 - What ? Search page
// 4 - Which search page ? Suppliers, ingredients, etc
// 5 - Which section? Filters, Marketing banner, bulk request
// 6 - what did the user do? click documents
// 7 - more details: SDS document

type TrackTreeEventParams = {
  /**
   * @example "Covalo", "PUIG", etc...
   */
  context: string;

  isAuthenticated: boolean;
  /**
   * @example "Search page", "Product page"
   */
  where: string;
  /**
   * @example "Filters", "Requests", 'Marketing banner'
   */
  section?: string;
  /**
   * @example "Click", "Submit"
   */
  action?: string;
  /**
   * @example "/detail/detail/detail"
   */
  extraDetails?: string;
  prefix?: string;
};
export const trackMatomoEvent = ({
  context,
  isAuthenticated,
  where,
  section,
  action,
  extraDetails,
  prefix = ''
}: TrackTreeEventParams) => {
  const event = `${prefix}${capitalizeFirstLetter(context)}/${
    isAuthenticated ? 'Authenticated' : 'Anonymous'
  }/${where}${section ? `/${section}` : ''}${action ? `/${action}` : ''}${
    extraDetails ? extraDetails : ''
  }`;
  piwik.push(['setCustomUrl', event]);
  piwik.push(['setDocumentTitle', `${event}`]);
  piwik.push(['trackPageView']);
};

export const trackMatomoPage = (params: TrackTreeEventParams) =>
  trackMatomoEvent({ ...params, prefix: 'Page open/' });
